export default __webpack_public_path__ + "static/media/mainicon.256c16e6.svg";